import {
    CreateCustomerReqDto,
    BookingParticipants,
    convertFullNameToNameDto,
    Country,
    Customer,
    Nationality,
} from '@travelity/api';

import { IBookingParticipantsForm } from './booking-participants.types';

export const stringToDate = (str: string): Date => {
    const [d, m, y] = str.split('.');
    if (!d || !m || !y) return new Date();

    return new Date(parseInt(y, 10), parseInt(m, 10), parseInt(d, 10));
};

export const customerFormToCustomer = (
    customer: Customer
): Omit<CreateCustomerReqDto, 'access'> => ({
    name: convertFullNameToNameDto(customer.fullName),
    contact_details: {
        emails: customer.emails?.map(({ value }) => value),
        phone_numbers: customer.numbers
            ?.map(({ value }) => value)
            .map(number => ({
                calling_code: parseInt(number.split(' ')[0], 10),
                number: parseInt(number.split(' ')[1], 10),
            })),
    },
    birth_details:
        customer.birthDate || customer.nationality || customer.birthPlace
            ? {
                  nationality:
                      (customer.nationality?.toLowerCase() as Nationality) ||
                      undefined,
                  date: customer.birthDate
                      ? Math.round(
                            stringToDate(customer.birthDate).getTime() / 1000
                        )
                      : undefined,
                  place: customer.birthPlace
                      ? {
                            name: customer.birthPlace,
                        }
                      : undefined,
              }
            : undefined,
    passport:
        customer.passportN || customer.citizenship
            ? {
                  number: customer.passportN || undefined,
                  citizenship:
                      (customer.citizenship?.toLowerCase() as Country) ||
                      undefined,
                  authority: customer.issuedBy,
                  issued_at: customer.issuedAt
                      ? Math.round(
                            stringToDate(customer.issuedAt).getTime() / 1000
                        )
                      : undefined,
                  expires_at: customer.expiresAt
                      ? Math.round(
                            stringToDate(customer.expiresAt).getTime() / 1000
                        )
                      : undefined,
              }
            : undefined,
    languages: customer.languages || [],
});

export const participantsToParticipantsForm = (
    participants: BookingParticipants
): IBookingParticipantsForm => ({
    pax: participants.pax,
    customer: participants.customer,
    travelers: participants.travelers || [],
});
